// variables.js
export const apiUrl = process.env.NODE_ENV === 'production'
    ? 'https://crmred.co/api'
    : 'http://127.0.0.1:8000/api';

export const APIURLAUTH = apiUrl + '/auth';

// Igual que PLATAFORMA_AUDITORIA_VIEWERS del backend: solo ellos ven la auditoría
// y gestionan los roles de plataforma. El backend responde 403 a los demás.
// En .env: VUE_APP_PLATAFORMA_AUDITORIA_VIEWERS=correo1,correo2
export const PLATAFORMA_AUDITORIA_VIEWERS = (process.env.VUE_APP_PLATAFORMA_AUDITORIA_VIEWERS || 'admin@crmred.co')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
export const IMGDEFOULT = 'https://res.cloudinary.com/reality-inmo/image/upload/v1690901467/depositphotos_259506188-stock-photo-illustration-picture-icon_zqbzcf.webp'
